import Webcam from "react-webcam";
import { AlertDialog, AlertDialogCancel, AlertDialogContent } from "../ui/alert-dialog";
import { X } from "lucide-react";
import { BrowserBarcodeReader } from "@zxing/library";
import { useEffect, useRef } from "react";
import BarcodeScannerComponent from "react-qr-barcode-scanner";

type P = {
    open?: boolean
    onOpenChange?: (open:boolean) => void
    onScan?: (value:string) => void
}

const BarcodeScanner = ({open, onOpenChange, onScan}:P) => {
    const videoConstraints = {
        facingMode: { exact: "environment" }
    };

    // const codeReaderRef = useRef<BrowserBarcodeReader | null>(null);
    // const webcamRef = useRef<Webcam>(null);

    // useEffect(() => {
    //     if(!open) { stopScanning(); return; } 
    //     codeReaderRef.current = new BrowserBarcodeReader();
    //     startScanning();

    //     return () => {
    //         stopScanning();
    //     };
    // }, [open]);

    // const startScanning = () => {
    //     const codeReader = codeReaderRef.current;
    //     const videoElement = webcamRef.current?.video;

    //     if (codeReader && videoElement) {
    //         codeReader.decodeFromVideoDevice(videoElement, "video", (result: any, _error: any) => {
    //             if (result) {
    //                 onScan && onScan(result.getText())
    //                 console.log("Barcode Result:", result.getText());
    //             }
    //         });
    //     }
    // };

    // const stopScanning = () => {
    //     const codeReader = codeReaderRef.current;
    //     if (codeReader) {
    //         codeReader.stopContinuousDecode();
    //     }
    // };

  return (
    <AlertDialog open={open} onOpenChange={(o)=>{onOpenChange && onOpenChange(o)}}>
        <AlertDialogContent className="max-h-dvh overflow-auto max-w-[100vw] h-full">
            <div className="grid grid-cols-[1fr,32fr,1fr]">
                <AlertDialogCancel asChild className="border-none w-fit"><button><X className="w-4 h-4"/></button></AlertDialogCancel>
                <div>
                    <p className="font-medium text-center">Barcode scanner</p>
                    <p className="text-sm text-center text-neutral-400">Breng de barcode in het getoonde vak</p>
                </div>
                <i></i>
            </div>
            
            <div className="relative p-2 border rounded-3xl max-h-[500px] overflow-auto ">
                <div className="w-full h-full overflow-hidden rounded-2xl">
                <BarcodeScannerComponent 
                    width={'auto'} 
                    height={500} 
                    onUpdate={(err, result)=>{ if(result?.getText()){ onScan && onScan(result?.getText() || '')}  }}
                    videoConstraints={videoConstraints}
                />
                </div>
                
            </div>


        </AlertDialogContent>
    </AlertDialog>
  )
}

export default BarcodeScanner